export class Utils {

    public static extractorArray(objectArray: Array<any>, type: string): Array<any> {
        let array = new Array();
        if (objectArray.length == 0) {
            return
        } else {
            objectArray.forEach((object) => {
                if (object[type] === 'true') {
                    array.push(object)
                }
            })
            return array
        }
    }

}